<template>
  <div class="component-container">
    <div class="search-container">
      <div class="search-by-department">
        <div class="search-by-radio-box">
          <input
            type="radio"
            name="office"
            id="company_1"
            value=""
            checked
            @change="setSearchToggle($event)"
          />
          <label
            class="search-label"
            :class="searchToggle !== '' ? 'label-disable' : ''"
            for="company_1"
            >Công ty</label
          >
        </div>
        <div class="search-by-radio-box">
          <input
            type="radio"
            name="office"
            id="department_1_1"
            value="SOFTWARE_DEVELOPMENT"
            @change="setSearchToggle($event)"
          />
          <label
            class="search-label"
            :class="
              searchToggle !== 'SOFTWARE_DEVELOPMENT' ? 'label-disable' : ''
            "
            for="department_1_1"
            >Khối PT1</label
          >
        </div>
        <div class="search-by-radio-box">
          <input
            type="radio"
            name="office"
            id="department_2_1"
            value="SOFTWARE_DEVELOPMENT_2"
            @change="setSearchToggle($event)"
          />
          <label
            class="search-label"
            :class="
              searchToggle !== 'SOFTWARE_DEVELOPMENT_2' ? 'label-disable' : ''
            "
            for="department_2_1"
            >Khối PT2</label
          >
        </div>
      </div>
      <div class="vertical-line" />
      <div class="search-year">
        <date-picker
          v-model="employeeParams.month"
          value-type="format"
          format="MM/YYYY"
          type="month"
          :clearable="false"
          :editable="false"
        >
          <i slot="icon-calendar">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.9997 2.66602H3.99967C2.52692 2.66602 1.33301 3.85992 1.33301 5.33268V11.9993C1.33301 13.4721 2.52692 14.666 3.99967 14.666H11.9997C13.4724 14.666 14.6663 13.4721 14.6663 11.9993V5.33268C14.6663 3.85992 13.4724 2.66602 11.9997 2.66602Z"
                stroke="#303C54"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M5.33301 1.33301V3.99967"
                stroke="#303C54"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M10.666 1.33301V3.99967"
                stroke="#303C54"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M1.33301 6.66602H14.6663"
                stroke="#303C54"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </i>
        </date-picker>
      </div>
    </div>
    <div class="chart-container" @wheel.prevent="rowChart">
      <v-chart
        :option="option"
        autoresize
        style="min-height: 500px; width: 100%"
      />
    </div>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { BarChart } from "echarts/charts";
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  ToolboxComponent,
  DataZoomComponent,
  TimelineComponent,
} from "echarts/components";
import VChart from "vue-echarts";
import moment from "moment";
import { mapGetters, mapActions } from "vuex";

use([
  CanvasRenderer,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  TimelineComponent,
  GridComponent,
  ToolboxComponent,
  DataZoomComponent,
  BarChart,
]);
const colors = ["#01959E", "#5E495A", "#EA6057"];

export default {
  name: "PersonInChargeProjects",
  components: {
    DatePicker,
    VChart,
  },
  data() {
    return {
      searchToggle: "",
      isMobile: false,
      option: {
        barWidth: 40,
        color: colors,
        grid: {
          right: "0",
        },
        legend: {
          textStyle: {
            fontFamily: "Helvetica",
            fontSize: 16,
            fontWeight: 400,
          },
          itemGap: 30,
          itemWidth: 20,
          itemHeight: 20,
          data: ["Maintain", "Spot", "Labo"],
          // data: ['Đang rảnh', 'Đang làm việc'],
        },
        dataZoom: {
          type: "inside",
          id: "insideX",
          disabled: true,
          startValue: 0,
          endValue: 2,
          zoomOnMouseWheel: false,
          moveOnMouseMove: true,
          moveOnMouseWheel: true,
        },
        xAxis: {
          type: "category",
          gridIndex: 0,
          axisLabel: {
            show: true,
            rotate: 0,
            width: 150,
            overflow: "truncate",
            ellipsis: true,
            fontFamily: "Helvetica",
            fontWeight: 500,
            fontSize: 12,
          },
          axisTick: {
            alignWithLabel: true,
          },
          offset: 10,
          // prettier-ignore
          data: [],
        },
        yAxis: {
          type: "value",
          name: this.$t("project.chart.project_amount"),
          position: "left",
          alignTicks: true,
          min: 0,
          max: function (value) {
            if (value.max < 5) {
              return 5;
            }
          },
          axisLine: {
            show: true,
          },
          axisLabel: {
            formatter: "{value}",
          },
          nameTextStyle: {
            fontSize: 16,
            fontFamily: "Helvetica",
            padding: [0, 0, 0, 12],
          },
        },
        series: [
          //ko thay doi thu tu object
          {
            id: 3,
            name: this.$t(
              "project.chart.person_in_charge_project_type_maintain"
            ),
            type: "bar",
            barGap: "0%",
            stack: null,
            data: [],
            label: {
              show: true,
              align: "center",
              fontSize: 14,
              fontWeight: 400,
              fontFamily: "Helvetica",
              color: "#FFFFFF",
              verticalAlign: "top",
              position: "insideTop",
              formatter: (param) => {
                return param.value > 0 ? param.value : '';
              }
            },
            barCategoryGap: "30%",
          },
          {
            id: 2,
            name: this.$t("project.chart.person_in_charge_project_type_spot"),
            type: "bar",
            barGap: "0%",
            stack: null,
            data: [],
            label: {
              show: true,
              align: "center",
              fontSize: 14,
              fontWeight: 400,
              fontFamily: "Helvetica",
              color: "#FFFFFF",
              verticalAlign: "top",
              position: "insideTop",
              formatter: (param) => {
                return param.value > 0 ? param.value : '';
              }
            },
            barCategoryGap: "30%",
          },
          {
            id: 1,
            name: this.$t("project.chart.person_in_charge_project_type_labo"),
            type: "bar",
            barGap: "0%",
            stack: null,
            data: [],
            label: {
              show: true,
              align: "center",
              fontSize: 14,
              fontWeight: 400,
              fontFamily: "Helvetica",
              color: "#FFFFFF",
              verticalAlign: "top",
              position: "insideTop",
              formatter: (param) => {
                return param.value > 0 ? param.value : '';
              }
            },
            barCategoryGap: "30%",
          },
        ],
      },
      employeeParams: {
        month: moment().format("MM/YYYY"),
        division: "",
      },
    };
  },
  async created() {
    this.setLoading(true);
    await this.onGetPerson();
    this.setLoading(false);
    this.updateData();
  },
  computed: {
    ...mapGetters({
      personChargeProjects: "project/personChargeProjects",
    }),
    checkMonth() {
      return this.employeeParams.month;
    },
  },
  watch: {
    checkMonth() {
      this.onChangeDate();
    },
    isMobile() {
      this.option.series.forEach((item) => {
        item.stack = this.isMobile ? "x" : null;
      });
      this.option.dataZoom.endValue = this.isMobile ? this.option.dataZoom.startValue + 1 :  this.option.dataZoom.startValue + 2;
    },
  },
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
    if (this.isMobile) {
      this.option.series.forEach((item) => {
        item.stack = "x";
      });
      this.option.dataZoom.endValue = this.option.dataZoom.startValue + 1;
    } else {
      this.option.series.forEach((item) => {
        item.stack = null;
      });
      this.option.dataZoom.endValue = this.option.dataZoom.startValue + 2;
    }
  },
  updated() {
    // Fired every second, should always be true
    // console.log("mounted");
  },
  methods: {
    ...mapActions("layout", ["setLoading"]),
    ...mapActions("project", ["getPersonChargeProjects"]),
    onResize() {
      this.isMobile = document.documentElement.clientWidth < 1421;
    },
    async onGetPerson() {
      let date = this.employeeParams.month.split("/");
      const params = { ...this.employeeParams, month: date[1] + "-" + date[0] };
      await this.getPersonChargeProjects(params);
      this.updateData();
    },
    async setSearchToggle(event) {
      this.searchToggle = event.target.value;
      this.employeeParams.division = this.searchToggle;
      await this.onGetPerson();
    },
    async onChangeDate() {
      await this.onGetPerson();
    },

    xAxisData(params) {
      const employeeName = [];
      params.forEach((item) => {
        employeeName.push(item.name);
      });
      return employeeName;
    },
    seriesData(params, key) {
      const employeeName = [];
      params.forEach((item) => {
        employeeName.push(item[`${key}`]);
      });
      return employeeName;
    },
    updateData() {
      this.option.xAxis.data = this.xAxisData(this.personChargeProjects);
      this.option.series[0].data = this.seriesData(
        this.personChargeProjects,
        "number_project_maintain"
      );
      this.option.series[1].data = this.seriesData(
        this.personChargeProjects,
        "number_project_spot"
      );
      this.option.series[2].data = this.seriesData(
        this.personChargeProjects,
        "number_project_labo"
      );
      // this.checkDataZoom();
    },
    rowChart(event) {
      if (event.deltaY > 0) {
        if (this.option.dataZoom.endValue < this.option.xAxis.data.length) {
          this.option.dataZoom.startValue += 1;
          this.option.dataZoom.endValue += 1;
        }
      } else {
        if (this.option.dataZoom.startValue > 0) {
          this.option.dataZoom.startValue -= 1;
          this.option.dataZoom.endValue -= 1;
        }
      }
    },
    // checkDataZoom() {
    //   if (this.option.xAxis.data.length < 5) {
    //     this.option.dataZoom.end = 100;
    //   }
    //   switch (this.option.xAxis.data.length) {
    //     case 5:
    //       this.option.dataZoom.end = 81;
    //     case 6:
    //       this.option.dataZoom.end = 67;
    //     case 7:
    //       this.option.dataZoom.end = 58;
    //     default:
    //       break;
    //   }
    // },
  },
};
</script>

<style scoped lang="scss">
label {
  margin-bottom: 0;
}

.chart-container {
  padding-top: 35px;
}

.search-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.search-by-department {
  display: flex;
  @media screen and (max-width: 1421px) {
    flex: 1 1 auto;
  }
}

.search-by-radio-box {
  padding-right: 12px;
}

.search-by-radio-box:last-child {
  padding-right: 0;
}

.search-year {
}

.vertical-line {
  border-left: 1px solid #d8d8d8;
  height: 4.5rem;
  margin: 0 14px;
}

.search-label {
  color: #303c54;
  width: 98px;
  border: 1px solid #dadada;
  border-radius: 10px;
  padding: 9px;
  font-size: 14px;
  margin-left: 6px;
  @media screen and (max-width: 1484px) {
    width: 80px;
  }
}

.mx-datepicker {
  width: 150px;
}
.label-disable {
  background-color: #f5f5f5;
}

/deep/ .mx-icon-calendar {
  color: white;
}
</style>
